import { faHeartCrack } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '@sixui/ui';
import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';

import { ContentBlock } from '~/components/molecules/ContentBlock';
import { Heading } from '~/components/molecules/Heading';

export type IInvitationPageProps = Record<string, never>;

export const InvitationDeclinedPage: React.FC<IInvitationPageProps> = () => {
  const { t } = useTranslation();

  return (
    <>
      <Helmet>
        <title>{t('InvitationDeclinedPage.seo.title')}</title>
      </Helmet>

      <Heading
        icon={<FontAwesomeIcon icon={faHeartCrack} />}
        title={t('InvitationDeclinedPage.title')}
      />

      <ContentBlock>
        <ContentBlock.Body first>
          <div>{t('InvitationDeclinedPage.body')}</div>
          <div>
            <Button href="/">{t('InvitationDeclinedPage.back')}</Button>
          </div>
        </ContentBlock.Body>
      </ContentBlock>
    </>
  );
};
